import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ax_token');
    const stored = localStorage.getItem('ax_user');
    if (token && stored) {
      try {
        const parsed = JSON.parse(stored);
        // If cached user is missing allowedApps or allowedFeatures (old session), re-fetch from server
        if (!parsed.allowedFeatures || !parsed.allowedApps) {
          api.post('/api/auth/refresh', {})
            .then(({ data }) => {
              localStorage.setItem('ax_user', JSON.stringify(data.user));
              setUser(data.user);
            })
            .catch(() => {
              // Token invalid — force logout
              localStorage.removeItem('ax_token');
              localStorage.removeItem('ax_user');
            })
            .finally(() => setLoading(false));
          return;
        }
        setUser(parsed);
      } catch {
        localStorage.removeItem('ax_token');
        localStorage.removeItem('ax_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/api/auth/login', { email, password });
    localStorage.setItem('ax_token', data.token);
    localStorage.setItem('ax_user', JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const ssoLogin = async (ssoToken) => {
    const { data } = await api.post('/api/auth/sso', { ssoToken });
    localStorage.setItem('ax_token', data.token);
    localStorage.setItem('ax_user', JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('ax_token');
    localStorage.removeItem('ax_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, ssoLogin, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
